/*
 * @Author: bbqin
 * @Date: 2022-01-24 15:25:42
 * @LastEditTime: 2022-09-26 14:48:39
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Form\infoGroupIcon.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';

require('./icon.less');

const Icons = [
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-1.svg`),
        name: '基础档案1',
        color: 'orange',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-2.svg`),
        name: '基础档案2',
        color: 'steelblue',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-3.svg`),
        name: '基础档案3',
        color: 'deepskyblue',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-4.svg`),
        name: '基础档案4',
        color: 'darkviolet',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-5.svg`),
        name: '基础档案5',
        color: 'deepskyblue',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-6.svg`),
        name: '基础档案6',
        color: 'springgreen',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-7.svg`),
        name: '基础档案7',
        color: 'orange',
    },
    {
        type: 'basicArchives',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-basic-archives-8.svg`),
        name: '基础档案8',
        color: 'springgreen',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-1.svg`),
        name: '业务处理1',
        color: 'orange',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-2.svg`),
        name: '业务处理2',
        color: 'steelblue',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-3.svg`),
        name: '业务处理3',
        color: 'deepskyblue',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-4.svg`),
        name: '业务处理4',
        color: 'darkviolet',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-5.svg`),
        name: '业务处理5',
        color: 'deepskyblue',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-6.svg`),
        name: '业务处理6',
        color: 'springgreen',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-7.svg`),
        name: '业务处理7',
        color: 'orange',
    },
    {
        type: 'businessProcessing',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-processing-8.svg`),
        name: '业务处理8',
        color: 'springgreen',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-1.svg`),
        name: '业务设置1',
        color: 'orange',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-2.svg`),
        name: '业务设置2',
        color: 'steelblue',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-3.svg`),
        name: '业务设置3',
        color: 'deepskyblue',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-4.svg`),
        name: '业务设置4',
        color: 'darkviolet',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-5.svg`),
        name: '业务设置5',
        color: 'deepskyblue',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-6.svg`),
        name: '业务设置6',
        color: 'springgreen',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-7.svg`),
        name: '业务设置7',
        color: 'orange',
    },
    {
        type: 'businessSetting',
        src: require(`../../../../static/images/pageMainIcon/formInfoGroupIcons/ig-business-setting-8.svg`),
        name: '业务设置8',
        color: 'springgreen',
    },
];

class FormInfoGroupIcon extends Component {
    render() {
        let { type, title, name, src } = this.props;

        try {
            src = src || require(`../../../../static/images/pageMainIcon/formCoreGroupIcon/cd-${name}.svg`);
        } catch (error) {
            console.log(error);
            src = '';
        }

        return <img
            src={src}
            className='info-group-icon'
            alt={title}
        />;
    }
}
FormInfoGroupIcon.Icons = Icons;
export default FormInfoGroupIcon;